import React, { useState } from 'react'

import PuiBaseTooltip, { PuiBaseTooltipProps } from './PuiBaseTooltip'

export interface PuiTooltipProps extends PuiBaseTooltipProps {
  readonly disabled?: boolean
  readonly openOnClick?: boolean
  readonly tooltipDelay?: number
}

const PuiTooltip = ({
  children,
  tooltipDelay,
  tooltipText,
  disabled,
  openOnClick,
  ...rest
}: PuiTooltipProps) => {
  const [open, setOpen] = useState(false)

  const openTooltip = () => {
    if (!disabled) {
      setOpen(true)
    }
  }

  if (!tooltipText) {
    return children
  }

  return (
    <PuiBaseTooltip
      disableFocusListener
      enterDelay={tooltipDelay}
      open={open}
      tooltipText={tooltipText}
      onClose={() => setOpen(false)}
      onOpen={() => !openOnClick && openTooltip()}
      {...rest}
    >
      {openOnClick ? (
        <span onClick={openTooltip} onMouseLeave={() => setOpen(false)}>
          {children}
        </span>
      ) : (
        children
      )}
    </PuiBaseTooltip>
  )
}

export default PuiTooltip
